export const VALID_ENVIRONMENTS = [
  'local',
  'dev',
  'test',
  'accp',
  'staff',
  'prod',
] as const;

export const Environments = {
  VALID_ENVIRONMENTS,
  isValid(env: string | undefined): boolean {
    // Type assertion ensures comparison against the defined literals
    return (VALID_ENVIRONMENTS as readonly string[]).includes(env || '');
  },
};
